import { Layouts } from 'react-grid-layout'
import { CustomLayout } from '../../../chart-kit/shared/utils/chartModel'

const usePresetChartLayout = (editedCharts: CustomLayout[]): Layouts => {
  const fixedLg = [
    { w: 12, h: 5, x: 0, y: 0, i: 'default-index2', moved: false, static: false },
    { w: 12, h: 5, x: 0, y: 5, i: 'Vorjahresvergleich-6', moved: false, static: false },
  ]

  const fixedMd = [
    { w: 12, h: 4, x: 0, y: 0, i: 'default-index2' },
    { w: 12, h: 4, x: 0, y: 4, i: 'Vorjahresvergleich-6' },
  ]

  const fixedXs = [
    { w: 1, h: 4, x: 0, y: 0, i: 'direktConsumptionProduction-4' },
    { w: 1, h: 4, x: 0, y: 4, i: 'Vorjahresvergleich-6' },
  ]

  const layoutsLg = editedCharts.map((chart, index) => ({
    i: String(chart.title) + '-' + (chart.id || 'index' + index),
    x: 0,
    y: fixedLg.reduce((prev, curr) => prev + curr.y, 0) + index,
    w: 12,
    h: 4,
  }))

  const layoutsMd = editedCharts.map((chart, index) => ({
    i: String(chart.title) + '-' + (chart.id || 'index' + index),
    x: 0,
    y: fixedMd.reduce((prev, curr) => prev + curr.y, 0) + index,
    w: 12,
    h: 4,
  }))

  const layoutsXs = editedCharts.map((chart, index) => ({
    i: String(chart.title) + '-' + (chart.id || 'index' + index),
    x: 0,
    y: fixedXs.reduce((prev, curr) => prev + curr.y, 0) + index,
    w: 1,
    h: 4,
  }))

  return { lg: [...fixedLg, ...layoutsLg], md: [...fixedMd, ...layoutsMd], xs: [...fixedXs, ...layoutsXs] }
}

export default usePresetChartLayout
